function formatDate(date:any) {
    return (
      [
        date
      ].join() 
      +
      ['T'].join() 
      +
      [ '00',
        '00',
        '00',
      ].join(':')
      + 
      ['.711Z']
    );
  }
  
  export default formatDate;